module.exports = __webpack_public_path__ + "media/images/teams/SAMPDORIA-459e0f63d7221de13ed3446f60e07a57.png";